<template>
  <div class="col-lg-3 order-2 order-lg-1">
    <div class="widgets">

      <aside class="single-widget widget-categories">
        <h6 class="widget-title">CATEGORIES</h6>
        <ul>
          <li><a href="shop-right-sidebar.html">Accessories <span>(18)</span></a></li>
          <li><a href="shop-right-sidebar.html">Kids <span>(16)</span></a></li>
          <li><a href="shop-right-sidebar.html">Men <span>(6)</span></a></li>
          <li><a href="shop-right-sidebar.html">Women <span>(11)</span></a></li>
        </ul>
      </aside>

      <aside class="single-widget widget-size">
        <h6 class="widget-title">SIZE</h6>
        <ul>
          <li><a href="shop-right-sidebar.html">S <span>(18)</span></a></li>
          <li><a href="shop-right-sidebar.html">M <span>(16)</span></a></li>
          <li><a href="shop-right-sidebar.html">L <span>(6)</span></a></li>
          <li><a href="shop-right-sidebar.html">XL <span>(11)</span></a></li>
          <li><a href="shop-right-sidebar.html">XXL <span>(11)</span></a></li>
        </ul>
      </aside>

      <aside class="single-widget widget-filter">
        <h6 class="widget-title">FILTER BY PRICE</h6>
        <div class="widget-filter-inner">
          <div class="range-slider" data-range_min="45" data-range_max="515" data-cur_min="180" data-cur_max="390">
            <div class="bar"></div>
            <span class="range-slider-leftgrip"></span>
            <span class="range-slider-rightgrip"></span>
          </div>
          <div class="widget-filter-bottom">
            <a href="#" class="add-to-cart-button">
              <span>FILTER</span>
            </a>
            <div class="widget-filter-price">
              <b>Price: </b> £<span class="range-slider-leftlabel"></span> - £<span class="range-slider-rightlabel"></span>
            </div>
          </div>

        </div>
      </aside>

      <aside class="single-widget widget-tags">
        <h6 class="widget-title">POPULAR TAGS</h6>
        <div class="tagscloud">
          <a href="shop-right-sidebar.html" data-rel="4">handbag</a>
          <a href="shop-right-sidebar.html" data-rel="6">laptop</a>
          <a href="shop-right-sidebar.html" data-rel="2">electronic</a>
          <a href="shop-right-sidebar.html" data-rel="8">television</a>
          <a href="shop-right-sidebar.html" data-rel="1">blouse</a>
          <a href="shop-right-sidebar.html" data-rel="7">tablet</a>
          <a href="shop-right-sidebar.html" data-rel="3">fashion</a>
          <a href="shop-right-sidebar.html" data-rel="5">hat</a>
        </div>
      </aside>

      <aside class="single-widget widget-compare">
        <h6 class="widget-title">COMPARE</h6>
        <ul>
          <li><a href="product-details-right-sidebar.html">Buscipit at magna</a> <span class="close"><i class="fa fa-close"></i></span></li>
          <li><a href="product-details-right-sidebar.html">Eleifend arcu</a> <span class="close"><i class="fa fa-close"></i></span></li>
        </ul>
        <div class="widget-compare-bottom">
          <a href="#" class="add-to-cart-button">
            <span>COMPARE</span>
          </a>
          <button class="clear-all">Clear all</button>
        </div>
      </aside>

    </div>
  </div>
</template>

<script>
    export default {
        name: "product-widgets"
    }
</script>

<style scoped>

</style>
